import { NgModule } from "@angular/core";
import { initializeApp, provideFirebaseApp } from "@angular/fire/app";
import { getDatabase, provideDatabase } from "@angular/fire/database";
import { environment } from "../../../environments/environment";

@NgModule({
  imports: [
    provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
    provideDatabase(() => getDatabase()),
  ],
})
export class CustomFirebaseModule {}
